// Utils
import { put, post } from 'app/shared/utils/fetchr';

import { RetrieveSarListResponse } from 'app/modules/fincenSAR/responses';
import {
  ChangeSarQueuePayload,
  ReassignSarPayload,
} from 'app/modules/fincenSAR/requests';

export const requeueSarApi = (
  payload: ChangeSarQueuePayload,
): Promise<RetrieveSarListResponse> => {
  return post('/sars/requeue', payload);
};

export const reassignSarApi = (
  payload: ReassignSarPayload,
): Promise<RetrieveSarListResponse> => {
  return put('/sars/bulk-reassign', payload);
};
